module.exports = __webpack_public_path__ + "img/flexsale-refined-5.7bb9b35a.png";